<template>
  <div class="demand-hall-floor floor-item">
    <div class="demand-wrap">
      <div class="head-title">
        <div class="l">
          <div class="title">
            需求大厅
          </div>
          <div
            v-for="(item, index) in demandType"
            :key="index"
            :class="['workers', demandIndex === index ? 'actived' : '']"
            @click="handleDemandType(index)"
          >
            {{ item.title }}
          </div>
        </div>
        <div class="right-more" @click="lookMoreDemand">
          查看更多 >>>
        </div>
      </div>
      <div v-if="demandList.length > 0">
        <!-- 找承包  -->
        <ul v-if="demandIndex === 0" class="demand-list">
          <li
            v-for="item in demandList"
            :key="item.reqGuid"
            class="demand-item"
            @click="demandDetail(item)"
          >
            <d-contract :source="item"></d-contract>
          </li>
        </ul>
        <!-- 找加工  -->
        <ul v-if="demandIndex === 1" class="demand-list">
          <li
            v-for="item in demandList"
            :key="item.reqGuid"
            class="demand-item"
            @click="demandDetail(item)"
          >
            <d-process :source="item"></d-process>
          </li>
        </ul>
        <!-- 找材料  -->
        <ul v-if="demandIndex === 2" class="demand-list">
          <li
            v-for="item in demandList"
            :key="item.reqGuid"
            class="demand-item"
            @click="demandDetail(item)"
          >
            <d-material :source="item"></d-material>
          </li>
        </ul>
        <!-- 找设计  -->
        <ul v-if="demandIndex === 3" class="demand-list">
          <li
            v-for="item in demandList"
            :key="item.reqGuid"
            class="demand-item"
            @click="demandDetail(item)"
          >
            <d-design :source="item"></d-design>
          </li>
        </ul>
        <!-- 找设备  -->
        <ul v-if="demandIndex === 4" class="demand-list">
          <li
            v-for="item in demandList"
            :key="item.reqGuid"
            class="demand-item"
            @click="demandDetail(item)"
          >
            <d-equipment :source="item"></d-equipment>
          </li>
        </ul>
        <!-- 找施工队 -->
        <ul v-if="demandIndex === 5" class="demand-list">
          <li
            v-for="item in demandList"
            :key="item.reqGuid"
            class="demand-item"
            @click="demandDetail(item)"
          >
            <d-working-team :source="item"></d-working-team>
          </li>
        </ul>
        <!-- 找工人 -->
        <ul v-if="demandIndex === 6" class="demand-list">
          <li
            v-for="item in demandList"
            :key="item.reqGuid"
            class="demand-item"
            @click="demandDetail(item)"
          >
            <d-worker :source="item"></d-worker>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// 找承包
import dContract from '../../DemandHall/component/dContract.vue'
// 找设计
import dDesign from '../../DemandHall/component/dDesign'
// 找设备
import dEquipment from '../../DemandHall/component/dEquipment'
// 找材料
import dMaterial from '../../DemandHall/component/dMaterial'
// 找加工
import dProcess from '../../DemandHall/component/dProcess'
// 找工人
import dWorker from '../../DemandHall/component/dWorker'
// 找施工队
import dWorkingTeam from '../../DemandHall/component/dWorkingTeam'
export default {
  components: {
    dContract,
    dDesign,
    dEquipment,
    dMaterial,
    dProcess,
    dWorker,
    dWorkingTeam
  },
  data() {
    return {
      demandIndex: 0,
      demandList: []
    }
  },
  computed: {
    ...mapState({
      demandType: state => state.demand.demandType
    })
  },
  created() {
    this.queryDemand()
  },
  methods: {
    // 获取需求列表
    queryDemand() {
      this.demandList = []
      this.$http
        .post(`${this.initUrl()}0/6`, {
          // 添加时间排序
          addtimeSort: 'Y',
          // 需求状态
          reqStatusList: [1]
        })
        .then(res => {
          if (res.data.content.length > 0) {
            this.demandList = res.data.content
            res.data.content.map(item => {
              item.province = this.handleProvince(item.province)
              item.city = this.handleCity(item.city)
              item.district = this.handleArea(item.district)
            })
          }
        })
    },

    initUrl() {
      let reqUrl = ''
      switch (this.demandIndex) {
        // 找承包
        case 0:
          reqUrl = `/cms/reqContract/findReqSpecification/`
          break
        // 找加工
        case 1:
          reqUrl = `/cms/reqProcess/findReqSpecification/`
          break
        // 找材料
        case 2:
          reqUrl = `/cms/reqMaterial/findReqSpecification/`
          break
        // 找设计
        case 3:
          reqUrl = `/cms/reqDesign/findReqSpecification/`
          break
        // 找设备
        case 4:
          reqUrl = `/cms/reqEquipment/findReqSpecification/`
          break
        // 找施工队
        case 5:
          reqUrl = `/cms/reqConstructionTeam/findReqSpecification/`
          break
        // 找工人
        case 6:
          reqUrl = `/cms/reqEmployee/findReqSpecification/`
          break

        default:
          reqUrl = `/cms/reqContract/findReqSpecification/`
          break
      }
      return reqUrl
    },

    // 切换需求类型
    handleDemandType(index) {
      this.demandIndex = index
      this.queryDemand()
    },

    handleProvince(pid) {
      const data = this.$store.getters.handleProvince(pid)
      if (isNaN(parseInt(pid)) || data === undefined) return
      return data.name
    },

    handleCity(cid) {
      const data = this.$store.getters.handleCity(cid)
      if (isNaN(parseInt(cid)) || data === undefined) return
      return '/ ' + data.name
    },

    handleArea(aid) {
      const data = this.$store.getters.handleAre(aid)
      if (isNaN(parseInt(aid)) || data === undefined) return
      return ' / ' + data.name
    },

    lookMoreDemand() {
      this.$router.push({
        path: '/demandHall',
        query: {
          name: this.demandType[this.demandIndex].title
        }
      })
    },

    demandDetail(item) {
      this.$router.push({
        path: `/demandDetail/${this.demandType[this.demandIndex].name}`,
        query: {
          id: item.reqGuid,
          from: 'hall',
          name: this.demandType[this.demandIndex].title
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
// 需求大厅
.demand-hall-floor {
  width: 1200px;
  margin: 0 auto;
  padding-top: 40px;
  .demand-wrap {
    width: 100%;
    height: 390px;
    background: #ffffff;
    .head-title {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 65px;
      padding: 0 20px;
      .l {
        height: 65px;
        display: flex;
        align-items: center;
      }
      .title {
        font-size: 22px;
        font-weight: bold;
        color: #333333;
        line-height: 30px;
        position: relative;
      }
      .title::after {
        content: '';
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -8px;
        width: 20px;
        height: 4px;
        background: #333333;
        border-radius: 2px;
      }
      .workers {
        font-size: 15px;
        color: #333333;
        line-height: 21px;
        margin-left: 30px;
        cursor: pointer;
      }
      .actived {
        color: #ce2939;
      }
      .right-more {
        cursor: pointer;
        font-size: 12px;
        color: #333333;
        line-height: 17px;
      }
    }
    ul.demand-list {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      padding: 0 20px;
      li {
        position: relative;
        width: 386px;
        height: 140px;
        border: 1px solid #e7e7e7;
        border-right: 1px solid #ffffff;
        display: flex;
        align-items: center;
        .emergrncy {
          position: absolute;
          left: 0;
          top: 0;
          width: 24px;
          height: 24px;
          img {
            width: 100%;
            height: auto;
          }
        }
        .demand-icon {
          width: 77px;
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          position: relative;
          img {
            width: 30px;
            height: 30px;
            margin-bottom: 3px;
          }
          p {
            font-size: 12px;
            color: #d85964;
            line-height: 17px;
          }
        }
        .demand-worker p {
          color: #8798f1;
        }
        .demand-icon::after {
          content: '';
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 1px;
          height: 96px;
          background: #ececec;
        }
        .demand-info {
          padding-left: 23px;
          .title {
            width: 270px;
            font-size: 14px;
            font-weight: bold;
            color: #333333;
            line-height: 20px;
            white-space: nowrap;
            margin-bottom: 10px;
            img {
              width: 15px;
              height: 15px;
              margin-left: 7px;
            }
          }
          .line {
            display: flex;
            align-items: center;
            margin-bottom: 3px;
            .l-info {
              width: 150px;
              padding-right: 10px;
            }
            .r-info {
              width: 120px;
              padding-right: 10px;
            }
            .phone {
              cursor: pointer;
              width: 66px;
              height: 20px;
              background: #c9646e;
              font-size: 10px;
              color: #ffffff;
              line-height: 18px;
              margin: 10px 16px 0 0;
              text-align: center;
            }
            .time {
              font-size: 10px;
              color: #d01c26;
              line-height: 14px;
              margin-top: 16px;
            }
          }
          .line-worker .l-info {
            width: 280px;
          }
        }
      }

      li:nth-child(3n + 1) {
        border-left: 1px solid #ffffff;
      }
      li:first-child,
      li:nth-child(2),
      li:nth-child(3) {
        border-bottom: 1px solid #ffffff;
      }
      li:nth-child(3n) {
        border-right: 1px solid #e7e7e7;
      }

      li:hover {
        box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.1);
        border-top: 1px solid #d01c26;
        border-left: 1px solid #d01c26;
        border-right: 1px solid #d01c26;
      }
      li.border-gray {
        border: 1px solid #e7e7e7;
      }
    }
  }

  .demand-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
